import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'kit-general-19',
  templateUrl: './19.component.html',
  styleUrls: ['./19.component.scss'],
})
export class CuiGeneral19Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
